import { render, staticRenderFns } from "./LenderTermsAndConditionsView.vue?vue&type=template&id=234b382a&scoped=true&"
import script from "./LenderTermsAndConditionsView.vue?vue&type=script&lang=js&"
export * from "./LenderTermsAndConditionsView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=234b382a&scoped=true&lang=css&"
import style1 from "./LenderTermsAndConditionsView.vue?vue&type=style&index=1&id=234b382a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234b382a",
  null
  
)

export default component.exports